// Terminal access day report. Latin-only content, so jsPDF's built-in fonts are safe here;
// the judicial (Chinese) reports are rendered server-side by ReportLab instead.
export async function buildDailyAccessReport({ stats, demo, officerId, headBlock }) {
  const stamp = new Date().toISOString().slice(0, 10);
  const { jsPDF } = await import("jspdf");
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  let y = 64;

  doc.setFillColor(9, 13, 20);
  doc.rect(0, 0, W, 108, "F");
  doc.setTextColor(226, 232, 240);
  doc.setFont("helvetica", "bold").setFontSize(17);
  doc.text("VERALIX AEGIS — TERMINAL ACCESS REPORT", 48, y);
  doc.setFont("courier", "normal").setFontSize(9).setTextColor(110, 168, 199);
  doc.text(`ZERO-TRUST PERIMETER GATE  ·  24H WINDOW  ·  ${stamp}`, 48, (y += 20));
  doc.setTextColor(148, 163, 184);
  doc.text(`OFFICER ${officerId || "—"}   TERMINAL AEGIS_CONSOLE_WEB`, 48, (y += 14));

  y = 152;
  if (demo) {
    doc.setFillColor(255, 244, 214);
    doc.rect(48, y - 14, W - 96, 22, "F");
    doc.setFont("courier", "bold").setFontSize(9).setTextColor(138, 101, 32);
    doc.text("DEMO DATA — PRESENTATION FIGURES, NOT LEDGER TRUTH", 60, y + 1);
    y += 28;
  }

  doc.setTextColor(15, 23, 42).setFont("helvetica", "bold").setFontSize(11);
  doc.text("1. ACCESS SUMMARY", 48, y);
  doc.setFont("courier", "normal").setFontSize(10).setTextColor(51, 65, 85);
  [
    ["Successful terminal unlocks", String(stats.access)],
    ["Blocked brute-force attempts", String(stats.blocked)],
    ["IP addresses currently locked out", String(stats.lockedIPs.length)],
    ["Lockout policy", "5 failed attempts / 15 minute lockout"],
    ["Session lifetime", "8 hours (single duty shift)"],
  ].forEach(([k, v]) => {
    doc.text(k, 62, (y += 20));
    doc.text(v, W - 62, y, { align: "right" });
    doc.setDrawColor(226, 232, 240).line(62, y + 6, W - 62, y + 6);
  });

  y += 40;
  doc.setFont("helvetica", "bold").setFontSize(11).setTextColor(15, 23, 42);
  doc.text("2. LOCKED SOURCE ADDRESSES", 48, y);
  doc.setFont("courier", "normal").setFontSize(10).setTextColor(168, 51, 44);
  if (stats.lockedIPs.length) {
    stats.lockedIPs.forEach((ip, i) => doc.text(`${String(i + 1).padStart(2, "0")}   ${ip}`, 62, (y += 18)));
  } else {
    doc.setTextColor(44, 115, 85).text("None — no source address is currently locked out.", 62, (y += 18));
  }

  y += 40;
  doc.setFont("helvetica", "bold").setFontSize(11).setTextColor(15, 23, 42);
  doc.text("3. LEDGER ATTESTATION", 48, y);
  doc.setFont("courier", "normal").setFontSize(9).setTextColor(51, 65, 85);
  [
    `Ledger height at issue      #${headBlock?.index ?? "—"}`,
    `Head block digest           ${(headBlock?.hash || "—").slice(0, 48)}`,
    "Every gate attempt in this window is recorded as an immutable WORM block",
    "(TERMINAL_GATE_UNLOCKED / TERMINAL_GATE_ACCESS_DENIED). The passcode itself",
    "is never written to any log, ledger payload or report.",
  ].forEach((line) => doc.text(line, 62, (y += 15)));

  doc.setTextColor(148, 163, 184).setFontSize(8);
  doc.text(`Generated ${new Date().toISOString()} · Veralix Aegis`, 48, doc.internal.pageSize.getHeight() - 40);

  const filename = `Veralix_Access_Report_${stamp}.pdf`;
  doc.save(filename);
  return filename;
}
